const FETCH_LIST_PROPERTIES_REQUEST = 'FETCH_LIST_PROPERTIES_REQUEST';
const FETCH_LIST_PROPERTIES_SUCCESS = 'FETCH_LIST_PROPERTIES_SUCCESS';
const FETCH_LIST_PROPERTIES_FAILURE = 'FETCH_LIST_PROPERTIES_FAILURE';

export { FETCH_LIST_PROPERTIES_REQUEST, FETCH_LIST_PROPERTIES_SUCCESS, FETCH_LIST_PROPERTIES_FAILURE };
